<script lang="ts">
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import type {
    ConfirmAppointmentsOutputs,
    ConfirmAppointmentsWorkflowEvent,
  } from "../../_shared/_logic/confirm-appointments-contract"

  let {
    outputs,
    readOnly = false,
    finishing = false,
    onEvent,
  }: {
    outputs: ConfirmAppointmentsOutputs
    readOnly?: boolean
    finishing?: boolean
    onEvent: (event: ConfirmAppointmentsWorkflowEvent) => Promise<void> | void
  } = $props()

  const confirmedCount = $derived(
    (outputs.confirm?.items ?? []).filter((item) => item.status === "confirmed").length,
  )
  const alreadyConfirmedCount = $derived(
    (outputs.confirm?.items ?? []).filter((item) => item.status === "already_confirmed").length,
  )
  const skippedConfirmCount = $derived(
    (outputs.confirm?.items ?? []).filter((item) => item.status === "skipped").length,
  )
  const queuedMailCount = $derived(
    (outputs.mail?.items ?? []).filter((item) => item.status === "queued").length,
  )
  const skippedMailCount = $derived(
    outputs.mail?.skippedByUser
      ? (outputs.confirm?.items ?? []).filter((item) =>
          ["confirmed", "already_confirmed"].includes(item.status),
        ).length
      : (outputs.mail?.items ?? []).filter((item) => item.status === "skipped").length,
  )

  const finish = async () => {
    if (finishing) return

    await onEvent({ type: "summary.finished", output: { finished: true } })
  }
</script>

<section class="summary-step">
  <div class="summary-grid">
    <div>
      <span>Bestätigt</span>
      <strong>{confirmedCount}</strong>
    </div>
    <div>
      <span>Bereits bestätigt</span>
      <strong>{alreadyConfirmedCount}</strong>
    </div>
    <div>
      <span>Übersprungen</span>
      <strong>{skippedConfirmCount}</strong>
    </div>
    <div>
      <span>Mails vorbereitet</span>
      <strong>{queuedMailCount}</strong>
    </div>
    <div>
      <span>Mails nicht gesendet</span>
      <strong>{skippedMailCount}</strong>
    </div>
  </div>
  {#if !readOnly}
    <div class="step-actions">
      <CTA
        type="primaryButton"
        content={finishing ? "Aktualisiere..." : "Fertig"}
        disabled={finishing}
        onClick={finish}
      />
    </div>
  {/if}
</section>

<style>
  .summary-step {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
  }

  .summary-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(12rem, 1fr));
    gap: 0.75rem;
  }

  .summary-grid div {
    border: 1px solid color-mix(in srgb, var(--text-100) 18%, transparent);
    padding: 0.8rem;
  }

  .summary-grid span {
    display: block;
    color: var(--text-100);
    font-size: 0.78rem;
    text-transform: uppercase;
  }

  .summary-grid strong {
    color: var(--text-100);
    font-size: 1.35rem;
  }

  .step-actions {
    display: flex;
    justify-content: flex-end;
  }
</style>
